import { CheckboxWithLabel, Section, Space, Typography } from '../../../../../../components/core-v2'
import Icon from '../../../../../../components/core-v2/atoms/Icon'
import LinkIcon from '../../../../../../components/core-v2/molecules/linkIcon'

type ConfirmationBoxProps = {
  elementTitle: string
  isApproved: boolean
  isAre: 'is' | 'are'
  onChangeIsApproved: (val: boolean) => void
  onClickEdit?: () => void
}

export const ConfirmationBox = ({
  elementTitle,
  isApproved,
  isAre,
  onChangeIsApproved,
  onClickEdit
}: ConfirmationBoxProps) => (
  <Space mt={5}>
    <Section px={5} py={6} type="primary">
      <Space isflex justifyContent="space-between">
        <CheckboxWithLabel
          checked={isApproved}
          data-testid={`confirm-${elementTitle.toLowerCase()}-checkbox`}
          onChange={val => onChangeIsApproved(val)}
        >
          Confirm {elementTitle}
        </CheckboxWithLabel>
        {onClickEdit && (
          <LinkIcon
            disabled={false}
            icon={<Icon name="chevronLeft" size="small" />}
            iconPosition="left"
            text={elementTitle === 'Note' ? 'Choose a different Note' : `Edit ${elementTitle}`}
            onClick={() => onClickEdit()}
          />
        )}
      </Space>
      <Space mt={5}>
        <Typography fontSize="12px" letterSpacing="0" variant="b3">
          Please confirm that the {elementTitle.charAt(0).toUpperCase() + elementTitle.slice(1)}
          &nbsp;{isAre} accurate before submitting the trade for approval.
        </Typography>
      </Space>
    </Section>
  </Space>
)
